import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { useNavigate } from 'react-router-dom'
import { Container, Typography, Button } from '@mui/material'
import { Add } from '@mui/icons-material'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import { Workflow } from 'types/traiwiss'
import GenericNotice from 'src/components/GenericNotice/GenericNotice'
import RouteContainer from 'src/components/App/RouteContainer'

const WorkflowList = React.lazy(() => loadComponent('traiwiss', 'WorkflowList'))

const StyledButton = styled(Button)`
    float: right;
`
const StyledHeadingText = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    float: left;
`

const StyledHeaderContainer = styled(Container)`
    height: 4vh;
`

export function WorkflowIndexRoute() {
    const navigate = useNavigate()
    const { academy, openFlightDeck } = useFlightDeck()

    const canDelete = usePermission('traiwiss.workflow.delete', { academy: academy?._id! })

    const onSelect = useCallback(
        (workflow: Workflow) => {
            navigate(`${workflow._id}/update`)
        },
        [navigate],
    )

    const onCreate = useCallback(() => {
        navigate(`/workflows/new`)
    }, [navigate])

    return (
        <RouteContainer>
            <StyledHeaderContainer disableGutters>
                <StyledHeadingText variant="h4">Workflows</StyledHeadingText>
                <StyledButton variant="contained" color="primary" onClick={() => onCreate?.()} startIcon={<Add />}>
                    neu
                </StyledButton>
            </StyledHeaderContainer>
            {!academy ? (
                <>
                    <GenericNotice
                        title="Keine Akademie ausgewählt"
                        message="Workflows gehören immer zu einer Akademie. Bitte wähle eine Akademie im Flight Deck aus, um dessen Workflows zu sehen">
                        <Button variant="contained" onClick={openFlightDeck}>
                            Flight Deck öffnen
                        </Button>
                    </GenericNotice>
                </>
            ) : (
                <WorkflowList academyId={academy?._id} onSelect={onSelect} canDelete={canDelete} />
            )}
        </RouteContainer>
    )
}
